import React from "react";

const DashboardAverageBookings = ({ stats }) => (
  <div
    className="p-4 rounded-4 h-100 d-flex align-items-center"
    style={{ background: "#B0B1B3" }}
  >
    <div className="lato-bold-20 text-uppercase" style={{ color: "#595959", fontWeight: 700 }}>
      <p>
        YTD MONTHLY
        <br />
        AVERAGE BOOKINGS
      </p>
    </div>
    <div style={{ flex: 1 }} />
    <div
      style={{
        width: 2,
        height: 48,
        background: "#595959",
        marginRight: 12,
        marginLeft: 0,
      }}
    />
    <div className="bebas" style={{ fontSize: 45, color: "#fff", fontWeight: 500 }}>
      {stats?.ytdMonthlyAverage || 0}
    </div>
  </div>
);

export default DashboardAverageBookings;